import {
  LanguagePicker,
  List,
  Modal,
  ModalTabs,
  OfferAuditView,
  PDFRenderer,
  Show,
} from "components";

import { LocationGenerics } from "router/location";
import SupportingDocument from "./components/supporting-document";
import _ from "lodash";
import config from "config";
import { processUrlData } from "utils/url";
import { useFormik } from "formik";
import { useOfferAuditTrail } from "hooks/data/use-offers";
import { useOfferSupportingDocuments } from "hooks/data/use-supporting-documents";
import { useSearch } from "react-location";
import { useState } from "react";

const externalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "PlaceIT Offer Slip",
    href: "PLACE_IT_PLACING_SLIP",
  },
  {
    name: "Supporting Documents",
    href: "SUPPORTING_DOCUMENTS",
  },
  {
    name: "Offer History",
    href: "INTERNAL_OFFER_HISTORY",
  },
];
const internalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "Supporting Documents",
    href: "INTERNAL_SUPPORTING_DOCUMENTS",
  },
  {
    name: "Offer History",
    href: "INTERNAL_OFFER_HISTORY",
  },
];

export default function ViewOfferSlipContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("PLACING_SLIP");
  const searchParams = useSearch<LocationGenerics>();
  const [id, type, place_it_id] = searchParams?.id?.split(":") || [];
  const { documents, loading } = useOfferSupportingDocuments({
    offerId: id || "",
  });
  const { offerHistory } = useOfferAuditTrail({
    input: { offerId: id || "" },
  });
  const form = useFormik({
    initialValues: {
      lang: "en",
    },
    onSubmit() { },
  });

  const urls = {
    PLACING_SLIP: `${config.asset.uri}generate_placing_slip/${processUrlData({
      offer_id: id,
      lang: form.values.lang,
    })
      }`,
    PLACE_IT_PLACING_SLIP: `${config.asset.placeItUri}/generate-broker-placing-slip/${place_it_id}`,
    SUPPORTING_DOCUMENTS: `${config.asset.placeItUri}/generate-broker-supporting-docs/${place_it_id}`,
    INTERNAL_SUPPORTING_DOCUMENTS: `${config.asset.uri}generate-broker-supporting-docs/${id}`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      size="6xl"
      title="Placing Slip"
      description="Details of placing slip are shown below"
      // hideActions
      hidePadding
    >
      <ModalTabs
        tabs={type === "PLACEIT" ? externalTabs : internalTabs}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      <Show if={orderStatus === "PLACING_SLIP"}>
        <div className="mb-3 p-3">
          {/* {searchParams?.id} */}
          <LanguagePicker id={"lang"} labelHidden {...form} />
        </div>
      </Show>

      <div className="space-y-4">
        <Show
          if={
            documents.length > 0 &&
            orderStatus === "INTERNAL_SUPPORTING_DOCUMENTS"
          }
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
            <List
              data={documents}
              renderItem={(doc) => (
                <SupportingDocument
                  key={doc}
                  documentName={doc}
                  offerId={id || ""}
                />
              )}
            />
          </div>
        </Show>

        <Show
          if={[
            "PLACING_SLIP",
            "PLACE_IT_PLACING_SLIP",
            "SUPPORTING_DOCUMENTS",
            "INTERNAL_SUPPORTING_DOCUMENTS",
          ].includes(orderStatus)}
        >
          <div className="bg-white rounded-2xl shadow">
            <PDFRenderer
              reloadToken={loading ? "" : String(Date.now())}
              url={_.get(urls, orderStatus)}
            />
          </div>
        </Show>
        <Show if={orderStatus === "INTERNAL_OFFER_HISTORY"}>
          <div className=" rounded-2xl p-4">
            <OfferAuditView history={offerHistory} />
          </div>
        </Show>
      </div>
    </Modal>
  );
}
